<template>
<div v-if="this.$route.fullPath === '/segmentacao/meus-grupos' || this.$route.query.page">
	<groupsList></groupsList>
</div>
<div v-else>
	<div class="content-wrapper content__wrapper" :aria-busy="loading ? 'true' : 'false'">
		<div v-if="!loading">
			<section class="content__custom">
				<div class="main-title">
					<h1 class="groups" hidden>
						{{ 'edit-groups' | translate }}
					</h1>
					<h1 class="groups" v-if="$route.fullPath.indexOf('editar') === -1">
						{{ 'create-group' | translate }}
					</h1>
				</div>
				<div class="boxes">
					<div class="box" v-if="groupRules[0].name !== 'LABEL_IS'">
						<div class="box__container">
							<div class="box__body">
								<form @submit.prevent="submitGroup">
									<div class="form__group">
										<label for="groups">{{ 'title' | translate | capitalize }}</label>
										<input id="groups-title" type="text"  @input="count($event, 40)" maxlength="40" v-model="groupName" required>
										<span id="counter-groups-title" class="label pull-right bg-red counter"></span>
									</div>
									<div class="form__group" v-if="groupFilterOperator">
										<ul class="form__group__option">
											<li>
												<input type="radio" id="all" name="operator" :value="'AND'" v-model="groupFilterOperator" :checked="(groupFilterOperator == 'AND')" @change="calculateRecipients()">
												<label for="all">{{ 'all' | translate | capitalize }}</label>
											</li>
											<li>
												<input type="radio" id="any" name="operator" :value="'OR'" v-model="groupFilterOperator" @change="calculateRecipients()">
												<label for="any">{{ 'any' | translate | capitalize  }}</label>
											</li>
										</ul>
									</div>
									<div v-for="(rule, index) in groupRules" :key="index" class="box__body__segment" >
										{{ rule.name }}
										<div class="form__wrap">
											<myRule
												:rule="rule"
												v-on:input="updateRule(...arguments, index)"
												v-if="showRules"/>

												<div class="form__wrap__group form__wrap__group--add">
													<span v-show="rulesLength - index > 1">{{ groupFilterOperator | lowercase | translate | lowercase }}</span>

													<button v-show="rulesLength - index == 1" type="button" class="button__icon button__icon--plus" @click="addRule(rule, index)" :disabled="!rule.name || !rule.data.value" title="Criar">
														Adicionar
													</button>

													<button class="button__icon button__icon--minus" v-show="rulesLength - index == 1 && groupRules.length !== 1" type="button" @click="removeRule(index)">
														Remover
													</button>
												</div>
										</div>
									</div>
									<div class="form__group">
										<div class="has-error" v-show="groupError">
											<label class="control-label" for="email">
												<i class="fas fa-times-circle-o"></i>
												{{ groupError }}
											</label>
										</div>
									</div>
									<div v-if="this.$route.fullPath.indexOf('criar') !== -1 || this.$route.fullPath.indexOf('duplicar') !== -1" class="form__group submit__content">
											<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'">
												{{ 'create-button' | translate }}
											</button>

									</div>

									<div class="box__footer" v-else>
										<ul class="counters" v-if="groupRules.length > 0 && countRecipients !== ''">
											<li class="counters__supporters">
													{{ countRecipients }}
											</li>
										</ul>

										<ul class="box__footer__buttons">
											<li>
												<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'">
													{{ 'create-button' | translate }}
												</button>
											</li>
											<li>
												<a type="button" class="nav-footer" @click="duplicateGroup">
													{{ 'clone' | translate | uppercase }}
												</a>
											</li>
											<li>
												<a type="button" class="nav-footer" @click="deleteGroup">
													{{ 'delete' | translate | uppercase }}
												</a>
											</li>
										</ul>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div v-if="this.$route.fullPath.indexOf('editar') !== -1" class="box">
						<div v-if="groupRecipients">
							<div class="main-title" v-if="(groupRecipients.length >= 1)">
								<h1 class="followers">
									{{ 'followersOfGroup' | translate | titleCase }}
									<strong>{{ groupName }}</strong>
								</h1>
							</div>
							<ul class="counters" v-if="countRecipients > 0">
								<li class="counters__supporters">
										{{ (groupRecipients) ? groupRecipients.length : '0' }}
									<template v-if="groupRecipients.length > 1">
										{{ 'supporters' | translate | lowercase }}
									</template>
									<template v-else>
									{{ 'supporter' | translate | lowercase }}
									</template>
								</li>
							</ul>

							<table class="table--fixed table-navigation" v-if="groupRecipients.length >= 1">
								<thead>
									<tr>
										<th class="name-cell">{{ 'name' | translate | titleCase }}</th>
										<th class="email-cell">{{ 'email' | translate | titleCase }}</th>
										<th class="phone-cell">{{ 'phone' | translate | titleCase }}</th>
										<th class="groups-cell">{{ 'groups' | translate | titleCase }}</th>
										<th class="intention-cell">{{ 'intentions' | translate | titleCase }}</th>
										<!-- <th class="
										ll">{{ 'gender' | translate | titleCase }}</th> -->
										<th class="platform-cell">{{ 'network' | translate | titleCase }}</th>
										<th class="date-cell">{{ 'date-of-interaction' | translate | titleCase }}</th>
									</tr>
								</thead>
								<tfoot v-if="groupRecipients.length >= 10">
									<tr>
										<th class="name-cell">{{ 'name' | translate | titleCase }}</th>
										<th class="email-cell">{{ 'email' | translate | titleCase }}</th>
										<th class="phone-cell">{{ 'phone' | translate | titleCase }}</th>
										<th class="groups-cell">{{ 'groups' | translate | titleCase }}</th>
										<th class="intention-cell">{{ 'intentions' | translate | titleCase }}</th>
										<!-- <th class="gender-cell">{{ 'gender' | translate | titleCase }}</th> -->
										<th class="platform-cell">{{ 'network' | translate | titleCase }}</th>
										<th class="date-cell">{{ 'date-of-interaction' | translate | titleCase }}</th>
									</tr>
								</tfoot>
								<tbody>
									<tr v-for="person in groupRecipients" :key="person.id" @click="detailsSupporters(person.id)">
										<td :title="'name' | translate" class="name-cell">{{ person.name }}</td>
										<td :title="'email' | translate" class="email-cell">{{ person.email }}</td>
										<td :title="'phone' | translate" class="intention-cell">{{ person.cellphone }}</td>
										<td :title="'groups' | translate" class="groups-cell">{{ person.group_count }}</td>
										<td :title="'intentions' | translate" class="intention-cell">{{ person.entity_count }}</td>
										<!-- <td :title="'gender' | translate" class="gender-cell"><i v-if="person.gender == 'F'" class="fas fa-female"></i><i class="fas fa-male" v-else></i></td> -->
										<td :title="'network' | translate" class="platform-cell"><i v-if="person.platform == 'facebook'" class="fas fa-facebook"></i><i v-if="person.platform == 'twitter'" class="fas fa-twitter"></i></td>
										<td :title="'first-interaction' | translate" class="date-cell">{{ person.created_at | date }}</td>
									</tr>
								</tbody>
							</table>

							<div class="content-empty" v-else>
								<p class="empty-state">{{ 'no-supporters-group' | translate | capitalize }}</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</div>
</template>
<script>

import myRule from './myRule.vue';
import groupsList from './groups.vue';

export default {
	name: 'groupsDetails',
	components: {
		myRule,
		groupsList,
	},
	data() {
		return {
			ruleIdPrefix: 'rule:',
			ruleIdCurrentIndex: 0,
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
				groupId: this.$route.params.id,
			},
			loading: false,
			submitLoading: false,
			showRules: false,
			groupError: '',
			groupId: '',
			pollAndQuestion: '',
		};
	},
	computed: {
		rulesLength() {
			return this.groupRules.length;
		},
		allGroups() {
			return (this.$store.state.group || {}).groups || {};
		},
		groupName: {
			get() {
				return this.$store.state.group.group.name;
			},
			set(value) {
				this.$store.commit('updateGroupName', value);
			},
		},
		groupFilterOperator: {
			get() {
				return this.$store.state.group.group.filter.operator;
			},
			set(value) {
				this.$store.commit('updateGroupFilterOperator', value);
			},
		},
		groupRules: {
			get() {
				return this.$store.state.group.group.filter.rules;
			},
			set() {

			},
		},
		groupRecipients() {
			return (this.$store.state.group.group || {}).recipients || [];
		},
		supporters() {
			return (this.$store.state.recipient.supporters || {}).recipients || {};
		},
		countRecipients() {
			return this.$store.state.group.countRecipients;
		},
	},
	methods: {
		updateRule(newRule, index) {
			this.calculateRecipients();
			this.groupRules.splice(index, 1, newRule);
		},
		toggleLoading() {
			this.loading = !this.loading;
		},
		detailsSupporters(id) {
			this.$router.push({ path: '/seguidor', query: { id } });
		},
		count(event, tam) {
			const lengthText = document.getElementById(`counter-${event.target.id}`);
			lengthText.textContent = (event.target.value.length - tam) * -1;
		},
		testCondition(conditionToTest) {
			if (
				this.$store.state.group.condition.length !== undefined && conditionToTest.length > 0
			) {
				return (
					this.$store.state.group.condition
						.filter(c => c.name === conditionToTest && c.has_value === 0).length > 0
				);
			}
			return true;
		},
		addRule() {
			const emptyRule = { name: '', data: { field: 0, value: '' } };
			this.$set(this.groupRules, this.groupRules.length, emptyRule);
		},
		removeRule(index) {
			this.$delete(this.groupRules, index);
		},
		calculateRecipients() {
			const validateRule = [...this.groupRules];

			validateRule.forEach((rule) => {
				if (rule.name || rule.data.value) {
					const objFilter = {
						session: this.session,
						operator: this.groupFilterOperator,
						rules: this.groupRules,
					};
					this.$store.dispatch('calculateRecipientsGroup', objFilter);
				}
			});
		},
		duplicateGroup() {
			this.$router.push({ path: `/grupos/duplicar/${this.$route.params.id}` });
		},
		getEditGroup() {
			if (this.$route.fullPath.indexOf('editar') !== -1) {
				this.toggleLoading();

				this.$store.dispatch('getGroup', this.session)
					.then(() => {
						this.calculateRecipients();
						this.$store.dispatch('getCondition', this.session)
							.then(() => {
								this.showRules = true;
							});
						this.$store.dispatch('getPolls', this.session)
							.then(() => {
								this.$store.dispatch('getActiveKnowledges', this.session)
									.then(() => {
										this.toggleLoading();
									});
							});
					})
					.catch(() => {
						this.toggleLoading();
					});
			}
		},
		getDuplicateGroup() {
			if (this.$route.fullPath.indexOf('duplicar') !== -1) {
				this.toggleLoading();

				this.$store.dispatch('getGroup', this.session)
					.then(() => {
						this.calculateRecipients();
						this.$store.dispatch('getCondition', this.session)
							.then(() => {
								this.showRules = true;
							});
						this.$store.dispatch('getPolls', this.session)
							.then(() => {
								this.$store.dispatch('getActiveKnowledges', this.session)
									.then(() => {
										this.groupRecipients = [];
										this.toggleLoading();
										this.groupName = `${this.groupName} CÓPIA`;
									});
							});
					})
					.catch(() => {
						this.toggleLoading();
					});
			}
		},
		getCreateGroup() {
			if (this.$route.fullPath.indexOf('criar') !== -1) {
				this.toggleLoading();
				this.$store.dispatch('getCondition', this.session)
					.then(() => {
						this.$store.dispatch('getPolls', this.session)
							.then(() => {
								this.$store.dispatch('getActiveKnowledges', this.session)
									.then(() => {
										this.showRules = true;
										this.toggleLoading();
									});
							});
					});
			}
		},
		submitGroup() {
			if (this.groupRules[0].name !== 'EMPTY' && this.groupRules[0].name !== '') {
				this.groupError = '';
				const validateRule = [...this.groupRules];
				validateRule.shift();

				validateRule.forEach((rule) => {
					if (!rule.name || !rule.data.value) {
						this.groupError = 'Verifique os campos vazios';
						setTimeout(() => {
							this.groupError = '';
						}, 8000);
					}
				});
			}

			const myRules = {};
			const objFilterPost = {};

			if (this.groupRules[0].name === '' || this.groupRules[0].name === 'EMPTY') {
				objFilterPost.name = this.groupName;
				objFilterPost.filter = {};
			} else {
				objFilterPost.name = this.groupName;
				objFilterPost.filter = {};
				objFilterPost.filter.rules = this.groupRules;
				objFilterPost.filter.operator = this.groupFilterOperator;
			}

			if (this.$route.params.id > 0) {
				myRules.operator = this.groupFilterOperator;
				myRules.rules = this.groupRules;
				objFilterPost.groupId = this.$route.params.id;
			}

			if (this.groupError === '') {
				if (this.$route.params.id > 0) {
					this.editGroup(objFilterPost);
				} else {
					this.createdGroup(objFilterPost);
				}
			}
		},
		editGroup(objFilterPost) {
			this.toggleSubmitLoading();
			this.$store.dispatch('editGroup', objFilterPost)
				.then(() => {
					this.toggleSubmitLoading();
					this.$router.push({ name: 'groups' });
				})
				.catch(() => {
					this.toggleSubmitLoading();
				});
		},
		createdGroup(objFilterPost) {
			this.$store.dispatch('createNewGroup', objFilterPost)
				.then((response) => {
					this.toggleSubmitLoading();
					this.groupId = response.data.id;
					this.$router.push({ name: 'groups' });
					// this.editGroup(objFilterPost);
				})
				.catch(() => {
					this.toggleSubmitLoading();
				});
		},
		deleteGroup() {
			if (this.$route.params.id) {
				const objFilterPost = {
					session: this.session,
					groupid: this.$route.params.id,
				};
				this.$store.dispatch('deleteGroup', objFilterPost).then(() => {
					this.$router.push({ name: 'groups', query: {} });
				});
			}
		},
		toggleSubmitLoading() {
			this.submitLoading = !this.submitLoading;
		},
	},
	watch: {
		$route(to) {
			if (to.fullPath.indexOf('duplicar') !== -1) {
				this.$set(this.session, 'groupId', 0);
				this.groupName = `${this.groupName} CÓPIA`;
			}
			if (to.fullPath.indexOf('editar') !== -1) {
				this.$set(this.session, 'groupId', this.$route.params.id);
				this.getEditGroup();
			}

			if (to.fullPath.indexOf('criar') !== -1) {
				this.$set(this.session, 'groupId', 0);
				const groupFilter = {
					operator: 'AND',
					rules: [
						{
							name: '',
							data: {
								field: '',
								value: '',
							},
						},
					],
				};
				const groupName = '';
				this.$store.commit('resetGroup', groupFilter);
				this.$store.commit('resetGroupName', groupName);
				this.$store.dispatch('getCondition', this.session);


				this.getCreateGroup();
			}
		},
	},
	mounted() {
		this.getEditGroup();
		this.getDuplicateGroup();
		this.getCreateGroup();
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/group/groupsDetails.vue